<template>
	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>交易账户列表</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 搜索筛选 -->
		<el-form :inline="true" class="user-search" :model="formInline" size="small">
			<!-- <el-form-item label="债券代码">
				<el-input v-model="formInline.bondCode"></el-input>
			</el-form-item>
			<el-form-item label="银行">
				<el-select v-model="formInline.city" placeholder="选择银行" clearable>
					<el-option :label="item" :value="item" v-for="(item,key) in manageCityList"
						:key="key">
					</el-option>
				</el-select>
			</el-form-item>


			<el-form-item label="是否持仓">
				<el-select v-model="formInline.isHold" placeholder="选择是否持仓" clearable>
					<el-option label="持仓" value="1">
					</el-option>
					<el-option label="已出" value="0">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="买入日期">
					<el-date-picker v-model="formInline.buyDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
					</el-date-picker>
			</el-form-item> -->
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
				<el-button size="small" type="danger" icon="el-icon-search" @click="add" v-if="jurisdiction.includes(501)">新增</el-button>
				<!-- <el-button size="small" type="primary" icon="el-icon-search" @click="updateBondHold" v-if="jurisdiction.includes(331)" >更新数据</el-button> -->
			</el-form-item>
		</el-form>

		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;" @selection-change="handleSelectionChange"
			:row-style='changeRowBgColor'>
            <el-table-column sortable prop="accountName" label="账户名称" width="200" align="center"></el-table-column>
            <el-table-column sortable prop="accountNo" label="账户账号" width="200" align="center"></el-table-column>
            <el-table-column sortable prop="accountLevel" label="账户级别" width="200" align="center"></el-table-column>
            <el-table-column sortable prop="accountParentName" label="上级账户名称" width="200" align="center"></el-table-column>
            <el-table-column sortable prop="accountParentNo" label="上级账户账号" width="200" align="center"></el-table-column>
            <el-table-column  prop="accountManager" label="投资经理" width="80" align="center"></el-table-column>
            <el-table-column  prop="accountTrader" label="交易员" width="80" align="center"></el-table-column>
            <el-table-column  prop="startTime" label="开始时间" width="150" align="center"></el-table-column>

			<el-table-column align="center" label="操作" min-width="100">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleedit( scope.row)" style="margin-right: 20px;" v-if="jurisdiction.includes(501)">修改</el-button>
                    <el-button slot="reference" size="mini" type="danger" icon="el-icon-delete"  @click="handledelete( scope.row)" v-if="jurisdiction.includes(502)">删除</el-button>
                </template>
            </el-table-column>
		</el-table>
		

		<!-- 分页组件 -->
		<Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>


		<el-dialog :close-on-click-modal="false" title="设置" :visible.sync="dialogVisible">
			<el-form :rules="rules" :model="editForm">
				<el-form-item label="账户名称：" label-width="140px">
				<el-input v-model="editForm.accountName"  style="width:200px"></el-input>
				</el-form-item>
                <el-form-item label="账户账号：" label-width="140px">
				<el-input v-model="editForm.accountNo"  style="width:200px"></el-input>
				</el-form-item>
                <el-form-item label="账户等级：" label-width="140px">
					<el-select clearable v-model="editForm.accountLevel" placeholder="选择账户等级" style="width:200px">
						<el-option label="1" value="1"></el-option>
						<el-option label="2" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="上级：" label-width="140px">
					<el-select v-model="editForm.accountParentId" placeholder="选择上级" clearable style="width:200px">
						<el-option :label="item.accountName" :value="item.id" v-for="(item,key) in transactionAccountLevel1"
							:key="key"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="投资经理：" label-width="140px">
				<el-input v-model="editForm.accountManager"  style="width:200px"></el-input>
				</el-form-item>
                <el-form-item label="交易员：" label-width="140px">
				<el-input v-model="editForm.accountTrader"  style="width:200px"></el-input>
				</el-form-item>
                <el-form-item label="开始日期：" label-width="140px">
					<el-date-picker v-model="editForm.startTime" type="date" value-format="yyyy-MM-dd" format="yyyy - MM - dd "  placeholder="选择日期" style="width:200px">
				</el-date-picker> 
                </el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="addEdit" >设置</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getTransactionAccountLevel1,
		getManageCity,
		addEditTransactionAccount,
		delTransactionAccount,
		getTransactionAccounts,
		updateBondHold
	} from '../../api/basisMG.js'
	// import methodsMixin from '@/utils/methodsMixin'
	// 导出模块
	export default {
		// mixins: [methodsMixin],

		// 模块数据
		data() {
			//数据  
			return {
				jurisdiction:JSON.parse(sessionStorage.getItem('jurisdiction')),
				isholdList:[{label:'持仓',value:1},{label:'已出',value:0}],
				transactionAccountLevel1: [],
				manageCityList:[],
				analysisMap:{},
				listData: [],
				alldata: false,
				checkAll: false,
				isIndeterminate: true,
				checkedLimit: [],

				loading: false,
				Visible: false,
				time: [],
				checkboxGroup: [],
				type: 'showVip',
				fileList: [],

				dialogImageUrl: '',
				dialogVisible: false,
				// 所属分类
				tableData: [],
				value: [],
				editForm: {},
				selectEditForm: {},
				usernames: ''
			}
		},
		watch: {},
		methods: {
			towNumber(val,len) {
				return parseFloat(val).toFixed(len)    
			},
			changeRowBgColor({ row }) { 
				let styleJson = {}
				if (row.isHold === 1){
				styleJson = { "color": "red" };} 
				return styleJson
			},
			getTransactionAccountLevel1() {
				getTransactionAccountLevel1().then(res => {
					if (res.code == '200') {
						this.transactionAccountLevel1 = res.data
					}
				})
				getManageCity().then(res => {
					if (res.code == '200') {
						this.manageCityList = res.data
						console.log("this.cityList",this.cityList)
					}
				})
			},
						// 获得数据
			getdata() {
				let param = this.formInline
				getTransactionAccounts(param).then(res => {
					this.saveParams(this.$route.path,param)
					if (res.code == '200') {
						this.listData = res.data.content
						this.pageparm.total = res.data.totalElements
					}
				})
			},

			updateBondHold(){
				let param = this.formInline
				updateBondHold(param).then(res => {
                    if (res.code == '200') {
                        this.$message({ 
                            type: 'success',
                            message:'设置成功'
                        })
                        this.getdata()
                        this.dialogVisible = false
                    }
                })
			},

			add() {
				this.dialogVisible=true
				this.editForm={}
			},
			handleedit(row) {
				console.log(row)
				this.dialogVisible = true
				this.editForm = Object.assign({}, row)
			},
            addEdit(){
                addEditTransactionAccount(this.editForm).then(res => {
                    if (res.code == '200') {
                        this.$message({ 
                            type: 'success',
                            message:'设置成功'
                        })
                        this.getdata()
                        this.dialogVisible = false
                    }
                })
            },

			// 删除
			handledelete(row) {
				let msg = '确认删除?'
				this.$confirm(msg, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delTransactionAccount({
						id: row.id
					}).then(res => {
						if (res.code == '200') {
							this.getdata()
						}
					})
				})
			},



		},
		// 创建前状态(里面是操作)
		beforeCreate() { },
		// 创建完毕状态(里面是操作)
		created() {
			this.getParams(this.$route.path)
			this.getdata()
			this.getTransactionAccountLevel1()
		},
		// 挂载前状态(里面是操作)
		beforeMount() { },
		// 挂载结束状态(里面是操作)
		mounted() { },
		// 更新前状态(里面是操作)
		beforeUpdate() { },
		// 更新完成状态(里面是操作)
		updated() { },
		// 销毁前状态(里面是操作)
		beforeDestroy() { },
		// 销毁完成状态(里面是操作)
		destroyed() { }
	};
</script>

<style scoped>
	.el-form-item {
		width: 30%;
		box-sizing: border-box;
	}

	.just-start {
		display: flex;
		justify-content: flex-start;
	}

	.marginT20 {
		margin-top: 20px;
	}
</style>